// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".order-list[data-v-2cb1ea5c]{max-width:100vw;min-height:70vh}.order-list .order-list-sections[data-v-2cb1ea5c]{border:1px dotted hsla(0,0%,66%,.612);border-radius:8px;max-width:96vw;position:relative}.order-list .order-list-sections .order-list-subtitle[data-v-2cb1ea5c]{background:#fff;left:9px;position:absolute;top:-28px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
